<template>
  <div class="relative">
    <div class="rounded-md" :style="{ backgroundColor: team?.theme?.base, color: team?.theme?.text, borderColor: useHexToRgba(team?.theme?.base, 1) }">
      <NuxtLink :to="{ name: 'team', params: { team: team.slug }}" class="block p-1.5" @click="onClickTeam(team)">
        <div class="flex items-center justify-between">
          <div class="flex gap-3 items-center">
            <div class="w-10 h-10 bg-white rounded-sm">
              <TeamLogo class="block w-full h-full" :name="team.name" :slug="team.slug" :logo="team.logo" size="128" :alt="team.abbr" />
            </div>
            <div class="space-y-1">
              <div class="font-heading font-bold text-lg">{{ team.name }}</div>
            </div>
          </div>
        </div>
      </NuxtLink>
    </div>
    <div class="absolute right-0 top-0 h-full flex items-center" :style="{ color: team?.theme?.text }" v-if="showButtons">
      <div class="flex items-center" v-auto-animate>
        <button class="p-3" v-if="team?.name" @click="user.removeFavorite(team)">
          <AtomIcon name="circle-xmark" class="text-lg" />
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
const user = useUserStore()
const { closeDrawer } = useAppDrawer()

const props = defineProps({
  team: {
    type: Object,
    default: () => {}
  },
  showButtons: {
    type: Boolean,
    default: () => true
  }
})

const onClickTeam = (team) => {
  closeDrawer()
  user.selectFavorite(team)
}
</script>
